// extracted by mini-css-extract-plugin
export default {"root":"ReferralInfo__root--35Oz5","link":"ReferralInfo__link--3ZVuw","rootMobile":"ReferralInfo__rootMobile--3IPBm"};